import { Integration } from 'api/integrations/requests';
import { request } from 'api/request';

type Option = {
  shortId: string;
  value: string;
  label: string;
  order?: number;
};

export type List = {
  id: string;
  shortId: string;
  name: string;
  source: string;
  numOptions: number;
  options: Option[];
  isHidden: boolean;
  listType: 'synced' | 'manual';
  dateCreated: Date;
  sync?: SyncListType;
};

export type SyncListType = {
  shortId: string;
  endpointUrl: string;
  mappingLabel: string;
  mappingValue: string;
  frequency: string;
  hasError: boolean;
  errorMessage: string;
  integration: Integration;
  isActive: boolean;
  lastSync: Date;
  mappingKeys?: string[];
};

export const loadLists = async (search: string = '') => {
  const response = await request.get<List[]>(`v1/company/lists/${search}`);
  return response.data;
};

export const loadList = async (id: string) => {
  const response = await request.get<List>(`v1/company/lists/${id}/`);
  return response.data;
};

type CreateOption = {
  value: string;
  label: string;
};

export type CreateListData = {
  name: string;
  source: string;
  options: CreateOption[];
};

export const createList = async (data: CreateListData) => {
  const response = await request.post('v1/company/lists/', data);
  return response.data;
};

export const editList = async (id: string, data: CreateListData) => {
  const response = await request.patch(`v1/company/lists/${id}/`, data);
  return response.data;
};

export const deleteList = async (id: string) => {
  const response = await request.delete(`v1/company/lists/${id}/`);
  return response.data;
};

export async function getListTemplate() {
  const response = await request.get(`v1/company/lists-create-template/`, {
    responseType: 'blob',
  });
  return response.data;
}

export type SyncListCreateData = {
  name: string;
  integrationId: string;
  endpointUrl: string;
  mappingLabel: string;
  mappingValue: string;
  isActive: boolean;
};

export const createSyncList = async (data: SyncListCreateData) => {
  const response = await request.postForm(`v1/integrations/synced-lists/`, data);
  return response.data;
};

export const patchSyncList = async (id: string, data: Partial<SyncListType>) => {
  const response = await request.patchForm(`v1/integrations/sync-list/${id}/`, data);
  return response.data;
};

export const syncList = async (id: string) => {
  const response = await request.post(`v1/integrations/sync-list/${id}/`);
  return response.data;
};

export const syncToManualList = async (id: string) => {
  const response = await request.delete(`v1/integrations/sync-list/${id}/`);
  return response.data;
};
